/**
 * Accordion Manager
 *
 * Gerenciador global de accordions reutilizável.
 * Usado pela PDP, FAQ e qualquer componente que precise de accordion animado.
 *
 * Uso:
 *   Trigger:  <button class="accordion-trigger" aria-expanded="false">
 *   Content:  <div class="accordion-content" data-open="false">
 *   Inner:    <div class="accordion-inner"> (overflow: hidden)
 *
 * @version 1.0.0
 * @author Wicomm
 */

/* ==========================================================================
   ACCORDION CONTROLLER
   Gerencia abrir/fechar de accordions via delegação de eventos
   ========================================================================== */

class AccordionController {
  /**
   * @param {Object} config
   * @param {string} config.triggerSelector - Seletor do botão trigger
   * @param {string} config.contentSelector - Seletor do conteúdo
   */
  constructor(config = {}) {
    this._config = {
      triggerSelector: '.accordion-trigger',
      contentSelector: '.accordion-content',
      ...config
    };

    this._handleClick = this._handleClick.bind(this);
    this._init();
  }

  /** @private */
  _init() {
    document.addEventListener('click', this._handleClick);
  }

  /**
   * Handler de clique via delegação
   * @private
   */
  _handleClick(e) {
    var trigger = e.target.closest(this._config.triggerSelector);
    if (!trigger) return;

    this.toggle(trigger);
  }

  /**
   * Alterna o estado de um accordion
   * @param {HTMLElement} trigger - Elemento trigger do accordion
   */
  toggle(trigger) {
    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', !isExpanded);

    var container = trigger.parentElement;
    var content = container.querySelector(this._config.contentSelector);

    if (content) {
      content.setAttribute('data-open', (!isExpanded).toString());
    }
  }

  destroy() {
    document.removeEventListener('click', this._handleClick);
  }
}

/* ==========================================================================
   INICIALIZAÇÃO GLOBAL
   ========================================================================== */

window.AccordionManager = new AccordionController();
